module.exports = __webpack_public_path__ + "img/pro_detail_1.80e014ed.jpg";